import { render, staticRenderFns } from "./BatchShipmentRequest.vue?vue&type=template&id=5d9d1967&scoped=true"
import script from "./BatchShipmentRequest.vue?vue&type=script&lang=js"
export * from "./BatchShipmentRequest.vue?vue&type=script&lang=js"
import style0 from "./BatchShipmentRequest.vue?vue&type=style&index=0&id=5d9d1967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9d1967",
  null
  
)

export default component.exports